import { render, staticRenderFns } from "./CreateCampaignReviewCardEmailSettings.vue?vue&type=template&id=9e02e85e&scoped=true"
import script from "./CreateCampaignReviewCardEmailSettings.vue?vue&type=script&lang=js"
export * from "./CreateCampaignReviewCardEmailSettings.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignReviewCardEmailSettings.vue?vue&type=style&index=0&id=9e02e85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e02e85e",
  null
  
)

export default component.exports